import React from 'react';

interface TermsConditionsProps {
  onBack?: () => void;
}

const TermsConditions = ({ onBack }: TermsConditionsProps) => {
  return (
    <div style={{ 
      backgroundColor: '#ffffff', 
      minHeight: '100vh',
      padding: '2rem 0'
    }}>
      <div className="container">
        <div style={{ 
          maxWidth: '800px', 
          margin: '0 auto',
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '1rem',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
        }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h1 style={{ 
              fontSize: '2.5rem', 
              fontWeight: 'bold', 
              color: '#111827',
              marginBottom: '1rem'
            }}>
              Termos e Condições
            </h1>
            <p style={{ color: '#6b7280', fontSize: '1rem' }}>
              Última atualização: Janeiro de 2024
            </p>
          </div>

          {/* Content */}
          <div style={{ lineHeight: '1.6', color: '#374151' }}>
            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                1. Aceitação dos Termos
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Ao utilizar os serviços da Beno, você concorda com estes Termos e Condições. 
                Se você não concorda com qualquer parte destes termos, não deve usar nossos serviços.
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                2. Descrição do Serviço
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                A Beno oferece um serviço de criação automatizada de sites para profissionais da saúde utilizando inteligência artificial. Nossos serviços incluem:
              </p>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>Criação automática de sites profissionais</li>
                <li style={{ marginBottom: '0.5rem' }}>Hospedagem e manutenção do site</li>
                <li style={{ marginBottom: '0.5rem' }}>Integração com WhatsApp e outras ferramentas</li>
                <li style={{ marginBottom: '0.5rem' }}>Otimização para motores de busca (SEO)</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                3. Elegibilidade
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Nossos serviços são destinados exclusivamente a profissionais licenciados da área da saúde no Brasil, incluindo:
              </p>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>Médicos registrados no CRM</li>
                <li style={{ marginBottom: '0.5rem' }}>Dentistas registrados no CRO</li>
                <li style={{ marginBottom: '0.5rem' }}>Psicólogos registrados no CRP</li>
                <li style={{ marginBottom: '0.5rem' }}>Nutricionistas registrados no CRN</li>
                <li style={{ marginBottom: '0.5rem' }}>Outros profissionais da saúde devidamente licenciados</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                4. Período de Teste Gratuito
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Oferecemos um período de teste gratuito de 7 dias para todos os novos usuários. Durante este período:
              </p>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>Você pode cancelar a qualquer momento sem custos</li>
                <li style={{ marginBottom: '0.5rem' }}>Após o período, a cobrança será iniciada automaticamente</li>
                <li style={{ marginBottom: '0.5rem' }}>Você será notificado antes do início da cobrança</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                5. Responsabilidades do Usuário
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Ao usar nossos serviços, você se compromete a:
              </p>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>Fornecer informações precisas e atualizadas</li>
                <li style={{ marginBottom: '0.5rem' }}>Manter a confidencialidade de suas credenciais de acesso</li>
                <li style={{ marginBottom: '0.5rem' }}>Cumprir todas as normas do CFM e conselhos profissionais</li>
                <li style={{ marginBottom: '0.5rem' }}>Não utilizar o serviço para atividades ilegais</li>
                <li style={{ marginBottom: '0.5rem' }}>Respeitar os direitos de propriedade intelectual</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                6. Conformidade com Regulamentações
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Nossos serviços são desenvolvidos em conformidade com:
              </p>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>Resolução CFM nº 1.974/2011 (publicidade médica)</li>
                <li style={{ marginBottom: '0.5rem' }}>Lei Geral de Proteção de Dados (LGPD)</li>
                <li style={{ marginBottom: '0.5rem' }}>Código de Ética Médica</li>
                <li style={{ marginBottom: '0.5rem' }}>Normas dos respectivos conselhos profissionais</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                7. Limitação de Responsabilidade
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                A Beno não se responsabiliza por:
              </p>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>Informações incorretas fornecidas pelo usuário</li>
                <li style={{ marginBottom: '0.5rem' }}>Uso inadequado do site criado</li>
                <li style={{ marginBottom: '0.5rem' }}>Interrupções temporárias do serviço</li>
                <li style={{ marginBottom: '0.5rem' }}>Decisões tomadas com base no conteúdo do site</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                8. Cancelamento e Reembolso
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                Você pode cancelar seu serviço a qualquer momento. Para cancelamentos:
              </p>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
                <li style={{ marginBottom: '0.5rem' }}>Durante o período gratuito: sem custos</li>
                <li style={{ marginBottom: '0.5rem' }}>Após cobrança: reembolso proporcional disponível</li>
                <li style={{ marginBottom: '0.5rem' }}>Site permanece ativo até o fim do período pago</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                9. Modificações dos Termos
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                A Beno se reserva o direito de modificar estes termos a qualquer momento. 
                As alterações serão comunicadas com 30 dias de antecedência e entrarão em vigor após este período.
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                10. Contato
              </h2>
              <p>
                Para dúvidas sobre estes termos, entre em contato: 
                <strong style={{ color: '#2563eb' }}> legal@beno.com.br</strong>
              </p>
            </section>
          </div>

          {/* Back Button */}
          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <button 
              onClick={onBack || (() => window.history.back())}
              style={{
                background: 'linear-gradient(45deg, #2563eb, #1d4ed8)',
                color: 'white',
                border: 'none',
                padding: '0.75rem 2rem',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            >
              ← Voltar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;